// fill in both in order to get proper intellisense
export type BaseDict = {
    MyPulseBets: string
    PlaceBet: string,
    PleaseLoginToPlaceBet: string,
    PulseBetInterval: string,
    PulseBetMsgGoal: string,
    PulseBetMsgWin: string,
    SortedHeading: string,
    ThirtySecPulse: string,
    OneMinPulse: string,
    FiveMinPulse: string,
    TenMinPulse: string,
    BetAgain: string,
    RepeatBet: string,
    NoOpenPulseBets: string
}

export const BaseDict: BaseDict = {
    MyPulseBets: "My Pulse Bets",
    PlaceBet: "Place Pulse Bet",
    PleaseLoginToPlaceBet: "Please Login",
    PulseBetInterval: "1 min Pulse",
    PulseBetMsgGoal: "Goal",
    PulseBetMsgWin: "You Won {0}!",
    SortedHeading: "1 min Pulse",
    ThirtySecPulse: "30 Sec",
    OneMinPulse: "1 min",
    FiveMinPulse: "5 min",
    TenMinPulse: "10 min",
    BetAgain: "BET AGAIN",
    RepeatBet: "REPEAT BET FOR {0}",
    NoOpenPulseBets: "You do not have any open pulse bets"
}